module.exports = __webpack_public_path__ + "static/media/home-comp-logos-cdm.ad7240f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-comp-logos-cdm.png
// module id = 267
// module chunks = 0